import React, { useCallback, useContext } from "react";
import { IAgGridCustomToolbarActionsParams } from "../../../../../util/component/AgGridCustomToolbar";
import {IconButton, Tooltip} from "@mui/material";
import { Stack } from "@mui/material/index";
import { DownloadRounded } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../../../../util/state/GlobalContextProvider";
import { useRecoilValue } from "recoil";
import { filterParams } from "../../../state";
import { useMutation } from "@tanstack/react-query";
import { downloadExpiredPractices, downloadExpiredPracticesCount } from "../../../services/http.services";
import { IDownloadExpiredPracticeFileReturn } from "../../../models/models";
import { setSnackbar } from "../../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../../util/state/globalVariables";
import { createFile } from "../../../utils";
import CustomLoader from "../../../../../util/component/CustomLoader";
import { FileType } from "../../../config";


const ToolbarActions = (params: IAgGridCustomToolbarActionsParams) => {
    const { t } = useTranslation('expiredManagement');
    const { dispatchGlobalData, globalData } = useContext(GlobalContext);

    const expiredPracticesFilter = useRecoilValue(filterParams);

    const downloadExpiredPracticesMutation = useMutation(
        downloadExpiredPractices,
        {
            onSuccess: (data: IDownloadExpiredPracticeFileReturn) => {

                createFile(data.file, data.fileName, FileType.XLSX);

            },
            onError: (err) => {
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t('translation:error.tryLater'),
                            type: snackbarTypes.error,
                            show: true,
                            autoClose: true
                        }
                    }
                });
            }
        }
    );

    const handleDownloadClick = useCallback(async () => {
        const visibleColDefs = (
            params.gridRef?.current?.columnApi
                .getAllDisplayedColumns()
                .map(c => c.getColDef())
                //.filter(c => !c.suppressColumnsToolPanel) 
                ?? []
        );

        const expiredPracticesCount = await downloadExpiredPracticesCount({
            filters: expiredPracticesFilter,
            auth: globalData?.user?.scopes,
            mobilityStores: globalData?.user?.mobilityStores?.map(((elem:any) => elem.sapId))
        });
        if (expiredPracticesCount > 1000) {
            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: t('Troppe righe per il download'),
                        type: snackbarTypes.error,
                        show: true,
                        autoClose: true
                    }
                }
            });
            return;
        }

        /*const sortBy =
                params.gridRef?.current.request.sortModel[0] ?
                    {
                        field: params.request.sortModel[0].colId,
                        order: params.request.sortModel[0].sort
                    } :
                    undefined;*/

        downloadExpiredPracticesMutation.mutate({
            filters: expiredPracticesFilter,
            fields: visibleColDefs.map(cd => ({
                field: cd.field ?? '',
                headerName: cd.headerName ?? ''
            })),
            auth: globalData?.user?.scopes,
            mobilityStores: globalData?.user?.mobilityStores?.map(((elem:any) => elem.sapId)),
            //sortBy: {field: '', order: ''}
        });
    }, [expiredPracticesFilter]);

    return (
        <>
            <Stack direction={"row"} display={"flex"} gap={1}>
                <Tooltip title={t('common.button.download')} arrow>
                    <IconButton color="accent" onClick={handleDownloadClick} sx={{mr: 2}}>
                        <DownloadRounded/>
                    </IconButton>
                </Tooltip>
            </Stack>
            <CustomLoader loading={downloadExpiredPracticesMutation.isLoading}/>
        </>
    );
};

export default ToolbarActions;
